import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]

import { ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { dateTime } from '@/core/date';
import AppModal from '@/core/components/AppModal.vue';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppSearchSelect from '@/core/components/form/AppSearchSelect.vue';
import { Option } from '@/core/components/form/Option';
import AppButton from '@/core/components/form/AppButton.vue';
import { Ticket, useTicket } from '@/modules/ticket/Ticket';

interface TicketViewMergeModalProps {
	ticket: Ticket;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketViewMergeModal',
  props: {
    ticket: {}
  },
  emits: [
	'cancel',
	'requestMerge',
],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();
const resource = useTicket();
const props = __props;
const destinationTicketId = ref<Ticket | null>(null);

const emit = __emit;

const searchTicketCallback = async (query: string): Promise<Option[]> => {
	const data = await resource.getAllNoPagination({
		free_search: query,
	});

	return data.map((ticket: Ticket): Option => ({
		value: String(ticket.id),
		label: `#${ticket.id} - ${dateTime(ticket.created_time)}`,
	}));
};

const cancel = () => {
	emit('cancel');
};

const requestMerge = () => {
	emit('requestMerge', destinationTicketId.value);
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(AppModal, { onClose: cancel }, {
    header: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("h1", null, [
        _createTextVNode(" Sammanfoga ärende #%{ id } ")
      ])), [
        [_directive_translate, {id: props.ticket.id}]
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(requestMerge, ["prevent"])
      }, [
        _withDirectives((_openBlock(), _createElementBlock("p", null, [
          _createTextVNode(" Vilket ärende vill du sammanfoga ärendet #%{ id } med? ")
        ])), [
          [_directive_translate, {id: props.ticket.id}]
        ]),
        _createVNode(AppFormGroup, {
          id: "ticket_merge_destination",
          label: _unref($gettext)('Sök ärendenummer')
        }, {
          default: _withCtx(() => [
            _createVNode(AppSearchSelect, {
              id: "ticket_merge_destination",
              modelValue: destinationTicketId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((destinationTicketId).value = $event)),
              "options-cb": searchTicketCallback
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createElementVNode("p", null, [
          _createVNode(AppButton, {
            type: "submit",
            class: "t-success"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Spara")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(AppButton, {
            onClick: cancel,
            class: "t-neutral"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Avbryt")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})